if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        if (this.isSizeXS()) {
          try {
            const hasXS = await this.checkIfXSInCart();
            if (hasXS) {
              this.submitForm(evt);
            } else {
              this.showXSWarningModal(() => {
                this.submitForm(evt);
              });
            }
          } catch (e) {
            console.error('Error checking cart:', e);
            this.showXSWarningModal(() => {
              this.submitForm(evt);
            });
          }
        } else {
          this.submitForm(evt);
        }
      }

      async checkIfXSInCart() {
        try {
          const response = await fetch(`${window.routes.cart_url}.js`);
          if (!response.ok) return false;
          const cart = await response.json();
          return cart.items.some(item => {
            if (item.options_with_values) {
              return item.options_with_values.some(opt => opt.value.trim().toUpperCase() === 'XS');
            }
            if (item.variant_options) {
              return item.variant_options.some(val => val.trim().toUpperCase() === 'XS');
            }
            if (item.variant_title) {
              return item.variant_title.split('/').some(val => val.trim().toUpperCase() === 'XS');
            }
            return false;
          });
        } catch (e) {
          return false;
        }
      }

      isSizeXS() {
        const container = this.closest('.product') || this.closest('quick-add-modal') || document;

        const checkedRadios = container.querySelectorAll('input[type="radio"]:checked');
        for (const radio of checkedRadios) {
          if (radio.value.trim().toUpperCase() === 'XS') {
            return true;
          }
        }

        const selectedOptions = container.querySelectorAll('select option:checked');
        for (const option of selectedOptions) {
          if (option.value.trim().toUpperCase() === 'XS') {
            return true;
          }
        }

        // Fallback over form.elements (HTML5 form-linked elements outside the tag)
        if (this.form && this.form.elements) {
          for (const el of this.form.elements) {
            if (el.type === 'radio' && el.checked) {
              if (el.value.trim().toUpperCase() === 'XS') {
                return true;
              }
            }
            if (el.tagName === 'SELECT') {
              const selectedOpt = el.options[el.selectedIndex];
              if (selectedOpt && selectedOpt.value.trim().toUpperCase() === 'XS') {
                return true;
              }
            }
          }
        }

        return false;
      }

      showXSWarningModal(onConfirm) {
        const existingModal = document.getElementById('tw-xs-warning-modal');
        if (existingModal) existingModal.remove();

        const modal = document.createElement('div');
        modal.id = 'tw-xs-warning-modal';
        modal.style.cssText = `
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.6);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 100000;
          opacity: 0;
          transition: opacity 0.3s ease;
        `;

        const content = document.createElement('div');
        content.style.cssText = `
          background-color: rgb(var(--color-background));
          color: rgb(var(--color-foreground));
          padding: 2.5rem;
          border-radius: var(--media-radius, 12px);
          max-width: 420px;
          width: 90%;
          box-shadow: 0 10px 30px rgba(0,0,0,0.25);
          text-align: center;
          transform: scale(0.9);
          transition: transform 0.3s ease;
          border: 1px solid rgba(var(--color-foreground), 0.1);
        `;

        const heading = document.createElement('h3');
        heading.innerText = 'Größe XS? Sicher?';
        heading.style.cssText = `
          margin-top: 0;
          margin-bottom: 1rem;
          font-size: 2.2rem;
          font-family: var(--font-heading-family);
          font-weight: 600;
        `;

        const text = document.createElement('p');
        text.innerText = 'Da passt ja kaum meine Katze rein';
        text.style.cssText = `
          margin-top: 0;
          margin-bottom: 2rem;
          font-size: 1.6rem;
          line-height: 1.5;
        `;

        const buttonWrapper = document.createElement('div');
        buttonWrapper.style.cssText = `
          display: flex;
          flex-direction: column;
          gap: 1rem;
        `;

        const changeButton = document.createElement('button');
        changeButton.type = 'button';
        changeButton.innerText = 'Größe ändern';
        changeButton.className = 'button button--primary';
        changeButton.style.cssText = `
          width: 100%;
          padding: 1.2rem;
          font-size: 1.5rem;
          cursor: pointer;
        `;

        const confirmButton = document.createElement('button');
        confirmButton.type = 'button';
        confirmButton.innerText = 'Ja, XS ist richtig!';
        confirmButton.className = 'button button--secondary';
        confirmButton.style.cssText = `
          width: 100%;
          padding: 1.2rem;
          font-size: 1.5rem;
          background: transparent;
          cursor: pointer;
        `;

        buttonWrapper.appendChild(changeButton);
        buttonWrapper.appendChild(confirmButton);
        content.appendChild(heading);
        content.appendChild(text);
        content.appendChild(buttonWrapper);
        modal.appendChild(content);
        document.body.appendChild(modal);

        setTimeout(() => {
          modal.style.opacity = '1';
          content.style.transform = 'scale(1)';
        }, 10);

        changeButton.addEventListener('click', () => {
          this.closeXSWarningModal(modal, content);
          const sizePicker = document.querySelector('[id^="VariantPicker"]');
          if (sizePicker) sizePicker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });

        confirmButton.addEventListener('click', () => {
          this.closeXSWarningModal(modal, content);
          onConfirm();
        });

        modal.addEventListener('click', (e) => {
          if (e.target === modal) {
            this.closeXSWarningModal(modal, content);
          }
        });
      }

      closeXSWarningModal(modal, content) {
        modal.style.opacity = '0';
        content.style.transform = 'scale(0.9)';
        setTimeout(() => {
          modal.remove();
        }, 300);
      }

      submitForm(evt) {
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measure('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure('add:paint-updated-sections', () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure('add:paint-updated-sections', () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.innerHTML = `
            <span class="tw-cart-button-icon" aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-cart" viewBox="0 0 40 40" fill="currentColor">
                <g transform="matrix(1.2297,0,0,1.13523,-15.2131,-13.9424)">
                  <path d="M20.503,21.133L23.739,21.069L23.732,22.872L41.021,23.02L36.26,31.376L28.262,31.339L27.035,33.861L39.013,33.995L38.879,35.936L23.02,35.936L26.031,31.653L26.031,29.244L22.427,22.834L20.557,22.862L20.503,21.133Z"/>
                </g>
                <g transform="matrix(1.42489,0,0,1.31542,-20.549,-21.3846)">
                  <circle cx="26.747" cy="39.277" r="1.686"/>
                </g>
                <g transform="matrix(1.42489,0,0,1.31542,-8.30418,-21.3846)">
                  <circle cx="26.747" cy="39.277" r="1.686"/>
                </g>
              </svg>
            </span>
            IN DEN WARENKORB
          `;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
